// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>12</span>&nbsp;&nbsp;I am forgotten like one that is dead, out of mind;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;I have become like a broken vessel.<br> </p> </div></div>";
// Exports
module.exports = code;